<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.1425 13L13.4871 7H6.79785L10.1425 13Z" fill="currentColor"/>
</svg>
